import { StoreTemplate } from "@/templates/TemplateLoader";
import { ReactNode } from "react";
import SectionContent from "@/templates/default/elements/SectionContent";
import PageHeader from "@/templates/default/elements/PageHeader";

const elements = {
  SectionContent,
  PageHeader,
};

export function SharedElementsLoader(props: { children: ReactNode }) {
  StoreTemplate.load("arab-hardware", "shared", elements);
  return props.children;
}
